module.exports = __webpack_public_path__ + "img/VintageGearbox.9a02a3f5.jpg";